import { useEffect, useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import LogoutOutlined from "@mui/icons-material/LogoutOutlined";
import UserIcon from "@mui/icons-material/Person";
import ArrowRight from "@mui/icons-material/ArrowRight";
import ConfigIcon from "@mui/icons-material/Settings";
import SearchIcon from "@mui/icons-material/Search";

import { styled } from "@mui/material/styles";
import { Outlet } from "react-router-dom";
import { colors, USER_DATA, USER_UUID } from "../utils/constants";
import { useNavigate } from "react-router-dom";
import "../screens/index.css";
import ButtonLoading from "./ButtonLoading";
import logo from "../assets/logo.png";
import { logout } from "../api/user";
import { useLocation } from "react-router-dom";
import Input from "./Input";
import moment from "moment";
import { Avatar, Link } from "@mui/material";

export default function ContainerMain({}) {
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState<User | null>(null);
  const navigate = useNavigate();
  const location = useLocation();

  interface User {
    name: string;
    role: string;
    client_id: string;
    test_period: string;
    subscriptionStatus: string;
  }

  useEffect(() => {
    const userData = localStorage.getItem(USER_DATA);
    if (userData) {
      setUser(JSON.parse(userData));
    }
  }, []);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  const doLogout = () => {
    logout();
    localStorage.clear();
    localStorage.removeItem(USER_DATA);
    localStorage.removeItem(USER_UUID);
    navigate("/login");
  };

  interface AppBarProps {
    open?: boolean;
  }

  const AppBar = styled(MuiAppBar)<AppBarProps>(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 1,
    background: "linear-gradient(135deg, #0060DF 0%, #0097FF 45%, #5EC8FF 100%)",
    boxShadow: "0 4px 20px -8px rgba(0,60,150,0.35)",
  }));

  const isMobile = window.innerWidth < 768;

  const testPeriodDate = moment(user?.test_period).format("DD/MM/YYYY");
  const isPeriodTest = moment().isBefore(moment(user?.test_period));

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      {user &&
        user.role == "admin" &&
        !location.pathname.includes("create") && (
          <Box
            style={{
              position: "fixed",
              bottom: isMobile ? 20 : 40,
              right: isMobile ? 20 : 50,
              zIndex: 9999,
            }}
          >
            <ButtonLoading
              onClick={() => navigate(`${user.client_id}/create`)}
              label={isMobile ? "" : "Gerenciar eventos"}
              endIcon={isMobile ? <ConfigIcon /> : <ArrowRight />}
              className="landing-hover-lift"
              style={{
                marginTop: 0,
                height: 50,
                fontSize: 14,
                borderRadius: 100,
                paddingLeft: 20,
                paddingRight: 20,
                boxShadow: "0 12px 28px -10px rgba(0,60,150,0.5)",
              }}
            />
          </Box>
        )}

      {/* {user &&
        user.role != "admin" &&
        !location.pathname.includes("create") && (
          <Box
            style={{
              position: "fixed",
              bottom: isMobile ? 20 : 20,
              left: isMobile ? 20 : 30,
              zIndex: 9999,
            }}
          >
            <ButtonLoading
              onClick={() => {
                window.open(
                  "https://api.whatsapp.com/send?phone=+5548991929692&text=Ol%C3%A1,%20gostei%20da%20ferramenta%20de%20certificados.%20Como%20fa%C3%A7o%20para%20usar%20a%20plataforma%20no%20meu%20evento?",
                  "_blank"
                );
              }}
              label={isMobile ? "Criar meu evento!" : "Quero criar meu evento!"}
              endIcon={<ArrowRight />}
              styleLabel={{ fontSize: 12 }}
              style={{
                marginTop: 0,
                height: 50,
                fontSize: 14,
                backgroundColor: "#FF0000",
              }}
            />
          </Box>
        )} */}

      <AppBar>
        {user?.role == "admin" &&
          isPeriodTest &&
          user?.subscriptionStatus != "ativo" && (
            <div
              style={{ backgroundColor: "red", padding: 6, paddingLeft: 24 }}
            >
              <span>
                Seu período de testes acaba em {testPeriodDate}. Mas você pode
                fazer o pagamento de um plano em{" "}
                <Link
                  style={{ color: "#fffb00" }}
                  href={`/${user?.client_id}/payments`}
                >
                  Meus Pagamentos
                </Link>
              </span>
            </div>
          )}

        {user?.role == "admin" &&
          !isPeriodTest &&
          user?.subscriptionStatus != "ativo" && (
            <div
              style={{ backgroundColor: "red", padding: 6, paddingLeft: 24 }}
            >
              <span>
                Seu período de testes já acabou. Faça o pagamento de um plano em{" "}
                <Link
                  style={{ color: "#fffb00" }}
                  href={`/${user?.client_id}/payments`}
                >
                  Meus Pagamentos
                </Link>
              </span>
            </div>
          )}

        <Toolbar
          style={{
            justifyContent: "space-between",
            display: "flex",
            marginTop:
              user?.role == "admin" && user?.subscriptionStatus != "ativo"
                ? -20
                : 0,
          }}
        >
          {/* logo */}
          <div
            style={{
              // width: "100%",
              justifyContent: "start",
              alignItems: "center",
              display: "flex",
            }}
          >
            <img src={logo} width={140} className="header-logo" />

            {!isMobile &&
              process.env.REACT_APP_ENV?.toUpperCase() === "DEVELOPMENT" && (
                <span
                  style={{
                    marginLeft: 16,
                    padding: "4px 12px",
                    borderRadius: 100,
                    backgroundColor: "rgba(255,255,255,0.18)",
                    border: "1px solid rgba(255,255,255,0.3)",
                    fontSize: 11,
                    fontWeight: 700,
                    letterSpacing: "0.04em",
                    color: "#fff",
                  }}
                  className="header-title"
                >
                  AMBIENTE DE DESENVOLVIMENTO
                </span>
              )}
          </div>

          {!isMobile && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                justifyContent: "start",
                width: 300,
                height: 44,
                backgroundColor: "rgba(255,255,255,0.95)",
                borderRadius: 12,
                padding: "0 14px",
                flexDirection: "row",
                gap: 8,
                boxShadow: "0 6px 16px -8px rgba(0,30,90,0.35)",
              }}
              onClick={() => navigate("/events")}
            >
              <SearchIcon style={{ color: "#7A8699", fontSize: 20 }} />
              <span style={{ color: "#5B6472", fontSize: 14 }}>
                Buscar eventos
              </span>
            </div>
          )}

          {/* logout */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: 4,
            }}
          >
            <Link
              href={`/profile`}
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
              }}
            >
              <IconButton
                color="inherit"
                size={"small"}
                style={{ marginLeft: 2, color: "#fff" }}
              >
                <UserIcon />
              </IconButton>
              <Typography
                component="span"
                variant="subtitle2"
                sx={{ flexGrow: 1, fontSize: 16, color: "#fff", mr: 2 }}
                className="header-username"
              >
                {user ? user.name : "User"}
              </Typography>
            </Link>
            <IconButton
              color="inherit"
              onClick={doLogout}
              size={"small"}
              style={{ marginLeft: 2 }}
            >
              <LogoutOutlined />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      <Outlet />
    </Box>
  );
}
